module.exports = __webpack_public_path__ + "static/media/chevron-up.cdea6f18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-up.svg
// module id = 171
// module chunks = 0